// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3g-Zh","search":"Settings_search__1kQ3j","filter":"Settings_filter__3xgZ3"};